export var RoomMode;
(function (RoomMode) {
    RoomMode["normal"] = "normal";
    RoomMode["conference"] = "conference";
})(RoomMode || (RoomMode = {}));
